import axios from "axios";
import {url} from "../utilities";
import {toastAlert} from "../toastAlert";

export const animal_catches_page = () => {

    $("#catchesTable").DataTable({
        stateSave: false,
        order: [1, 'desc']
    });

    let animalTypeSelect = $('#addAnimalCatch_animal_type_id, #editAnimalCatch_animal_type_id');

    if($('#addAnimalCatch_animal_type_id, #editAnimalCatch_animal_type_id').children("option:selected").data('has_many_animals')){
        $(".animals").show();
    }else{
        $(".animals").hide();
    }

    animalTypeSelect.on('change', async function (e) {
        e.preventDefault();
        let id = $(this).children("option:selected").val();

        try {
            let response = await axios.get(url(`api/app/dictionary/animals?type_id=${id}`));
            let select = $("#addAnimalCatch_animal_id, #editAnimalCatch_animal_id");

            $(this).children("option[value='0']").remove();

            if ($(this).children("option:selected").data('has_many_animals')) {
                $(".animals").show();
            }else{
                $(".animals").hide();
            }


            select.empty();

            let data = response.data;

            for (let animal of data.animals) {
                select.append(`<option value=${animal.id}>${animal.name}</option>`);
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodawania odłowu', {type: 'danger'})
        }

    });

}